import angular from 'angular';
import DisconnectOffersDbss from './disconnect.offers.dbss.component';
import { routing } from './disconnect.offers.dbss.config';
export default angular.module('invision.customercare.customer.disconnectoffersDbss', []).component('disconnectOffersDbss', DisconnectOffersDbss).config(routing).name;